import React from 'react';
import { Link } from 'react-router-dom';

function StepNineteen() {
    return (
        <div className="step-form text-center">
            <div className="success-icon mb-4">
                <div className="rounded-circle bg-success-subtle d-inline-flex align-items-center justify-content-center" style={{ width: 80, height: 80 }}>
                    <img src='assets/success_icon.png' alt="Success" />
                </div>
            </div>

            <h2 className="mt-3">All done!</h2>
            <p className="mt-3 max-w-500 text-muted">
                Thank you for completing your assessment. Your application has been successfully submitted and is now being reviewed by our team.
            </p>

            <p className="max-w-500 text-muted">
                We'll contact you shortly with next steps. In the meantime, if you have any questions, please don't hesitate to reach out.
            </p>


        </div>
    );
}

export default StepNineteen;